const PYAEmptyIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 130 127" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <g>
        <path
          opacity={0.61}
          d="M72.2452 113.394C101.02 113.394 124.348 90.2452 124.348 61.59C124.348 32.9347 100.917 9.78613 72.2452 9.78613C43.4706 9.78613 20.1426 32.9347 20.1426 61.59C20.1426 90.2452 43.4706 113.394 72.2452 113.394Z"
          fill="#E9EAF3"
        />
        <path
          d="M120.956 27.6325C123.283 27.6325 125.169 25.7606 125.169 23.4515C125.169 21.1424 123.283 19.2705 120.956 19.2705C118.629 19.2705 116.742 21.1424 116.742 23.4515C116.742 25.7606 118.629 27.6325 120.956 27.6325Z"
          fill="#E9EAF3"
        />
        <path
          d="M127.122 11.3161C128.711 11.3161 129.999 10.0378 129.999 8.4608C129.999 6.88384 128.711 5.60547 127.122 5.60547C125.532 5.60547 124.244 6.88384 124.244 8.4608C124.244 10.0378 125.532 11.3161 127.122 11.3161Z"
          fill="#E9EAF3"
        />
        <path
          d="M22.9165 27.529C24.5057 27.529 25.794 26.2506 25.794 24.6737C25.794 23.0967 24.5057 21.8184 22.9165 21.8184C21.3273 21.8184 20.0391 23.0967 20.0391 24.6737C20.0391 26.2506 21.3273 27.529 22.9165 27.529Z"
          fill="#E9EAF3"
        />
        <path
          d="M5.34386 82.5987C8.29519 82.5987 10.6877 80.2246 10.6877 77.2959C10.6877 74.3673 8.29519 71.9932 5.34386 71.9932C2.39253 71.9932 0 74.3673 0 77.2959C0 80.2246 2.39253 82.5987 5.34386 82.5987Z"
          fill="#E9EAF3"
        />
        <g>
          <g filter="url(#filter0_d_1693_19526)">
            <path
              d="M105.9 36.738L106.682 99.216C106.682 101.35 104.923 103 102.772 103H41.3736C39.2227 103 37.4629 101.253 37.4629 99.216V18.8871C37.4629 16.7528 39.2227 15.1035 41.3736 15.1035H85.8578L105.9 36.738Z"
              fill="#C62828"
              fillOpacity={0.01}
              shapeRendering="crispEdges"
            />
          </g>
          <path
            d="M107.7 35.6869L108.522 101.36C108.522 103.603 106.673 105.337 104.412 105.337H39.8743C37.6135 105.337 35.7637 103.501 35.7637 101.36V16.9234C35.7637 14.6799 37.6135 12.9463 39.8743 12.9463H86.6331L107.7 35.6869Z"
            fill="white"
          />
        </g>
        <path
          d="M67.2085 92.1829H64.8448C64.331 92.1829 63.9199 91.6731 63.9199 91.0612C63.9199 90.4493 64.331 89.9395 64.8448 89.9395H67.2085C67.7223 89.9395 68.1334 90.4493 68.1334 91.0612C68.1334 91.775 67.7223 92.1829 67.2085 92.1829Z"
          fill="#E9EAF3"
        />
        <path
          d="M60.0159 92.1829H46.2452C45.7314 92.1829 45.3203 91.6731 45.3203 91.0612C45.3203 90.4493 45.7314 89.9395 46.2452 89.9395H60.0159C60.5298 89.9395 60.9408 90.4493 60.9408 91.0612C60.9408 91.775 60.5298 92.1829 60.0159 92.1829Z"
          fill="#E9EAF3"
        />
        <path
          d="M77.589 26.7139H46.6563C45.9369 26.7139 45.3203 26.102 45.3203 25.3882C45.3203 24.6744 45.9369 24.0625 46.6563 24.0625H77.589C78.3084 24.0625 78.925 24.6744 78.925 25.3882C78.925 26.102 78.3084 26.7139 77.589 26.7139Z"
          fill="#E9EAF3"
        />
        <path
          d="M58.5772 34.0576H46.6563C45.9369 34.0576 45.3203 33.4458 45.3203 32.7319C45.3203 32.0181 45.9369 31.4062 46.6563 31.4062H58.4744C59.1938 31.4062 59.8104 32.0181 59.8104 32.7319C59.8104 33.4458 59.1938 34.0576 58.5772 34.0576Z"
          fill="#E9EAF3"
        />
        <path d="M86.6328 12.9463V31.098C86.6328 33.6474 88.8937 35.6869 91.4628 35.6869H107.7" fill="#CACBD7" />
        <g filter="url(#filter1_d_1693_19526)">
          <path
            d="M112.633 106.868C111.605 106.868 110.577 106.461 109.755 105.543L92.5931 88.5128L91.9765 88.9207C86.4271 92.9997 79.9529 95.1412 73.3758 95.1412C65.4628 95.1412 57.5497 91.98 51.6921 86.4733C45.5261 80.6606 42.1348 72.8085 42.1348 64.2425C42.1348 47.2125 56.111 33.3438 73.273 33.3438C84.9884 33.3438 95.2651 39.4623 100.814 49.8639C106.261 60.1634 105.542 72.1966 98.8619 81.8843L98.4508 82.4962L115.716 99.6282C117.463 101.362 117.052 103.095 116.743 104.013C115.921 105.645 114.277 106.868 112.633 106.868ZM73.273 41.8078C60.7355 41.8078 50.6644 51.9034 50.6644 64.2425C50.6644 78.3152 62.277 86.7792 73.5813 86.7792C80.4667 86.7792 86.7354 83.7199 91.1544 78.2132C96.601 71.4828 97.5259 62.4069 93.7236 54.5548C89.8184 46.7026 82.0082 41.8078 73.273 41.8078Z"
            fill="#C62828"
            fillOpacity={0.01}
            shapeRendering="crispEdges"
          />
        </g>
        <path
          d="M112.633 106.868C111.605 106.868 110.577 106.461 109.755 105.543L92.5931 88.5128L91.9765 88.9207C86.4271 92.9997 79.9529 95.1412 73.3758 95.1412C65.4628 95.1412 57.5497 91.98 51.6921 86.4733C45.5261 80.6606 42.1348 72.8085 42.1348 64.2425C42.1348 47.2125 56.111 33.3438 73.273 33.3438C84.9884 33.3438 95.2651 39.4623 100.814 49.8639C106.261 60.1634 105.542 72.1966 98.8619 81.8843L98.4508 82.4962L115.716 99.6282C117.463 101.362 117.052 103.095 116.743 104.013C115.921 105.645 114.277 106.868 112.633 106.868ZM73.273 41.8078C60.7355 41.8078 50.6644 51.9034 50.6644 64.2425C50.6644 78.3152 62.277 86.7792 73.5813 86.7792C80.4667 86.7792 86.7354 83.7199 91.1544 78.2132C96.601 71.4828 97.5259 62.4069 93.7236 54.5548C89.8184 46.7026 82.0082 41.8078 73.273 41.8078Z"
          fill="#CACBD7"
        />
      </g>
    </g>
    <defs>
      <filter
        x={18.1477}
        y={0.0806012}
        width={107.849}
        height={126.527}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4.29226} />
        <feGaussianBlur stdDeviation={9.65759} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0441319 0 0 0 0 0.0568021 0 0 0 0 0.170833 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1693_19526" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1693_19526" result="shape" />
      </filter>
      <filter
        x={37.1271}
        y={30.4822}
        width={84.9}
        height={83.5397}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2.14613} />
        <feGaussianBlur stdDeviation={2.50382} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0441319 0 0 0 0 0.0568021 0 0 0 0 0.170833 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1693_19526" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1693_19526" result="shape" />
      </filter>
    </defs>
  </svg>
);

export { PYAEmptyIcon };
